import { render, staticRenderFns } from "./AutoDMMetrics.vue?vue&type=template&id=e178c0a8&"
import script from "./AutoDMMetrics.vue?vue&type=script&lang=js&"
export * from "./AutoDMMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports